import axios, { AxiosInstance } from 'axios';
import { ElMessage, ElMessageBox } from 'element-plus';
import { store } from '@/store/store';
import qs from 'qs';

// 配置新建一个 axios 实例
const service: AxiosInstance = axios.create({
  baseURL: store.state.config.api,
  timeout: 80000,
  headers: { 'Content-Type': 'application/json' },
  paramsSerializer: {
    serialize(params) {
      return qs.stringify(params, { allowDots: true });
    },
  },
});

// 添加请求拦截器
service.interceptors.request.use(
  (config) => {
    config.baseURL = store.state.config.api;
    if (config.method === 'get') {
      (config as any).headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
    }
    else if (config.method === 'post') {
      (config as any).headers['Content-Type'] = 'application/json;charset=utf-8';
    }
    (config as any).headers['idappset'] = store.state.config.idappset;    
    (config as any).headers['idtoken'] = store.state.user.idtoken;
    (config as any).headers['id'] = store.state.user.id;
    (config as any).headers['cip'] = store.state.app.ip;
    (config as any).headers['device'] = store.state.app.device;
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
service.interceptors.response.use(
  async (response) => {
    return response.data;
  },
  err => {
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          err.message = '请求错误'
          break
        case 401:
          err.message = '未授权，请登录'
          break
        case 403:
          err.message = '拒绝访问'
          break
        case 404:
          err.message = `请求地址出错: ${err.response.config.url}`
          break
        case 408:
          err.message = '请求超时'
          break
        case 500:
          err.message = '服务器内部错误'
          break
        case 501:
          err.message = '服务未实现'
          break
        case 502:
          err.message = '网关错误'
          break
        case 503:
          err.message = '服务不可用'
          break
        case 504:
          err.message = '网关超时'
          break
        case 505:
          err.message = 'HTTP版本不受支持'
          break
        default:
          err.message = 'api访问出错'
      }
    }
    console.error(err)
    return Promise.reject(err)
  }
);

// 导出 axios 实例
export default service;
